var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 160,
    viewBox: "0 0 513 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2842_55235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.199219 48C0.199219 25.3726 0.199219 14.0589 7.22866 7.02944C14.2581 0 25.5718 0 48.1992 0H464.199C486.827 0 498.14 0 505.17 7.02944C512.199 14.0589 512.199 25.3726 512.199 48V112C512.199 134.627 512.199 145.941 505.17 152.971C498.14 160 486.827 160 464.199 160H48.1992C25.5718 160 14.2581 160 7.22866 152.971C0.199219 145.941 0.199219 134.627 0.199219 112V48Z",
    fill: "#6200EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.676 127.584L417.484 128.178L379.937 213.671",
    stroke: "#311B92",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.862 82.7727L372.87 85.7339L307.034 232.33",
    stroke: "#311B92",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81.0609 40.1197L66.1433 25.3538L70.0455 -62.1151",
    stroke: "#311B92",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81.1375 77.2283L117.966 55.0577L126.084 -95.0632",
    stroke: "#311B92",
    strokeWidth: 30
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2842_55235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.199219 48C0.199219 25.3726 0.199219 14.0589 7.22866 7.02944C14.2581 0 25.5718 0 48.1992 0H464.199C486.827 0 498.14 0 505.17 7.02944C512.199 14.0589 512.199 25.3726 512.199 48V112C512.199 134.627 512.199 145.941 505.17 152.971C498.14 160 486.827 160 464.199 160H48.1992C25.5718 160 14.2581 160 7.22866 152.971C0.199219 145.941 0.199219 134.627 0.199219 112V48Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWallet);
export default __webpack_public_path__ + "static/media/blue-wallet.f09a4fc1a577e1af6511a6ec87e3357f.svg";
export { ForwardRef as ReactComponent };